var map = {
	"./components/bienvenida/bienvenida.module": [
		"./src/app/components/bienvenida/bienvenida.module.ts",
		"components-bienvenida-bienvenida-module"
	],
	"./components/change-pass/change-pass.module": [
		"./src/app/components/change-pass/change-pass.module.ts",
		"components-change-pass-change-pass-module"
	],
	"./components/home/home.module": [
		"./src/app/components/home/home.module.ts",
		"components-home-home-module"
	],
	"./components/recuperar-pass/recuperar-pass.module": [
		"./src/app/components/recuperar-pass/recuperar-pass.module.ts",
		"components-recuperar-pass-recuperar-pass-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;